module.exports = __webpack_public_path__ + "static/media/Scan_and_Order.4fdddfe9.png";